export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/remux": [4],
		"/settings": [5,[2]],
		"/settings/accessibility": [6,[2]],
		"/settings/advanced": [7,[2]],
		"/settings/appearance": [8,[2]],
		"/settings/audio": [9,[2]],
		"/settings/debug": [10,[2]],
		"/settings/instances": [11,[2]],
		"/settings/local": [12,[2]],
		"/settings/metadata": [13,[2]],
		"/settings/privacy": [14,[2]],
		"/settings/video": [15,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';